import React from "react";
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import './App.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap/dist/js/bootstrap.bundle.min.js'; 

import Home from "./components/Home";
import PrivacyPolicy from "./components/PrivacyPolicy";
import CancellationPolicy from "./components/CancellationPolicy";
import NotFound from "./components/NotFound";
import GiftVoucher from "./components/GiftVoucher";


const App = () => {
  return (
    <>
      <Router>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/privacypolicy" element={<PrivacyPolicy />} />
          <Route path="/storno" element={<CancellationPolicy />} />
          <Route path="*" element={<NotFound />} />
          <Route path="/giftvoucher" element={<GiftVoucher />} />
        </Routes>
      </Router>
    </>
  );
};

export default App;
